import { http } from "@/core/api/";
import generalService from "@/services/pei/general";
import qs from 'qs';

const apiBaseUrl = "/api/studentevaluation";

export default {
  /**
     *
     * @param {StudentSieID
            ComparisonDate
            EvaluationServiceType // 2=additionalEvaluation enum type
            ExcludedEvaluations
            SelectedEvaluations
            evaluationDateId
            IsInitialPostRegistry
            isDisabled} model
     */
  async getEvaluationForEligilibility(model) {
    return await http.get(`${apiBaseUrl}/studentevaluationforeligibility`, {
      params: model
    });
  },
  async getDifficult(id) {
    return await http.get(`${apiBaseUrl}/getdifficult/${id}`);
  },
  async getSelectedEvaluations(Ids) {
    return await http.get(`${apiBaseUrl}/selectedevaluations`, {
      params: {
        evaluationsIds: Ids || ""
      }
    });
  },
  /**
   *
   * @param {studentSie, endDate, selectedEvaluations } model
   */
  async getAvailablesEvaluations(model) {
    return await http.get(`${apiBaseUrl}/availablestudentsevaluations`, {
      params: model
    });
  },
  /**
   *
   * @param {*} model
   */
  async saveEvaluation(model) {
    return await http.post(`${apiBaseUrl}/save`, model);
  },
  /**
   *
   * @param {*} model
   */
  async updateEvaluation(model) {
    return await http.post(`${apiBaseUrl}/update`, model);
  },
  async updateTriannualParticipantSignatures(evaluationDateId, signatures) {
    return await http.put(
      `${apiBaseUrl}/${evaluationDateId}/participant-signatures`,
      signatures
    );
  },
  /**
   *
   * @param { studentEvaluationId, documentType } model
   */
  async replaceDocument(model, file) {
    const formData = new FormData();
    formData.append("File", file);

    return await http.post(
      `${apiBaseUrl}/${model.studentEvaluationId}/replacedocument?documentTypeId=${model.documentType}`,
      formData
    );
  },
  /**
   *
   * @param studentEvaluationId
   */
  async changeDeterminationToPending(studentEvaluationId, comment) {
    return await http.post(
      `${apiBaseUrl}/${studentEvaluationId}/changedeterminationstatus`,
      null,
      {
        params: { comment }
      }
    );
  },
  async restorePreviousDiscussionStatus(studentEvaluationId) {
    return await http.put(
      `${apiBaseUrl}/${studentEvaluationId}/restorepreviousdiscussionstatus`
    );
  },
  /**
   *
   * @param { studentEvaluationId, documentType } model
   */
  async addDocument(model, file) {
    const formData = new FormData();
    formData.append("File", file);

    return await http.post(
      `${apiBaseUrl}/${model.studentEvaluationId}/document?documentTypeId=${model.documentType}`,
      formData
    );
  },

  async eligibilityDeterminationForm(studentSie, evaluationDateId) {
    return await http.get(
      `${apiBaseUrl}/${studentSie}/EligibilityDeterminationForm/${evaluationDateId}`
    );
  },
  async changePreviousDate(evaluationId, evaluationDate) {
    return await http.put(
      `${apiBaseUrl}/changepreviousdate/${evaluationId}?previousDate=${evaluationDate}`
    );
  },
  async approvalLetterDownload(requestServiceId) {
    const { data: response } = await http.get(
      `${apiBaseUrl}/disciplineapprovalletterdownload?RequestServiceId=${requestServiceId}`
    );
    if (response && response.document) {
      // browser will download the PDF received by the server.
      generalService.documentDownloadReport(
        response.document.content,
        response.document.filename
      );
    }
    // send the letter's props
    return response;
  },
  async supportDocumentDownload(studentReferralId) {
    const { data: response } = await http.get(
      `${apiBaseUrl}/supportdocuments/${studentReferralId}`
    );
    if (response) {
      // browser will download the PDF received by the server.
      generalService.documentDownloadReport(
        response.content,
        response.filename
      );
    }
    // send the letter's props
    return response;
  },

  async getEvaluationByCommetteeId(placementCommitteeId) {
    if(placementCommitteeId > 0) {
      return await http.get(`${apiBaseUrl}/evaluationbycommetteeid/${placementCommitteeId}`);
    }
  },

  async getBriefEvaluationInfoByCommetteeId(placementCommitteeId) {
    if(placementCommitteeId > 0) {
      return await http.get(`${apiBaseUrl}/briefevaluationsbycommetteeid/${placementCommitteeId}`);
    }
  },
};

export const getHistory = params =>
  http.get(`${apiBaseUrl}/gethistory`, { params });

export const getBaseRemProRequestData = (studentSieId, evaluationIds) => 
  http.get(`${apiBaseUrl}/rp/requestfromevaluations/${studentSieId}`,
  { 
    params: { evaluationIds },
    paramsSerializer: params => qs.stringify(params)
  });
  
export const saveRemProRequest = (payload) => 
  http.post(`${apiBaseUrl}/rp/requestfromevaluations`, payload);

export const revertExcludedStatus = (studentEvaluationId) =>
  http.put(`${apiBaseUrl}/${studentEvaluationId}/revertexcludedstatus`);
